import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initScrollingVideo = () => {
	const videos = document.querySelectorAll('.text-block__video')

	videos.forEach(video => {
		ScrollTrigger.create({
			trigger: video,
			start: 'top 60%',
			once: true,
			onEnter: () => {
				video.play()
			}
		})
	})
}

export default () => { }